module.exports = __webpack_public_path__ + "img/REPLACEMENT-WORK-IN-CAFE-PARK-ETC2-scaled.e67567aa.jpg";